import request from '@/utils/request'

let ArticleApi = {
  /*文章列表*/
  articlelist(data) {
    return request._post('/shop/plus.article.article/index', data);
  },
  /*获取文章分类*/
  getCategory(data) {
    return request._post('/shop/plus.article.category/index', data);
  },
  /*添加文章*/
  toAddArticle(data) {
    return request._get('/shop/plus.article.article/add', data);
  },
  /*添加文章*/
  addArticle(data) {
    return request._post('/shop/plus.article.article/add', data);
  },
  /*文章详情*/
  toEditArticle(data) {
    return request._get('/shop/plus.article.article/edit', data);
  },
  /*编辑文章*/
  editArticle(data) {
    return request._post('/shop/plus.article.article/edit', data);
  },
  /*删除文章*/
  deleteArticle(data) {
    return request._post('/shop/plus.article.article/delete', data);
  },
  /*添加分类*/
  addCategiry(data) {
    return request._post('/shop/plus.article.category/add', data);
  },
  /*编辑分类*/
  editCategory(data) {
    return request._post('/shop/plus.article.category/edit', data);
  },
  /*删除分类*/
  deleteCategory(data) {
    return request._post('/shop/plus.article.category/delete', data);
  },

  /*获取公众号素材信息*/
  getMpMaterialCount(data) {
    return request._post('/shop/plus.article.article/getMpInfoCount', data);
  },

  /*同步公众号素材信息*/
  postMpMaterial(data) {
    return request._post('/shop/plus.article.article/postMpInfo', data);
  },
   /*
      @Author:weiruibo
      @Date:2020年11月12日

      获取文章分类图片
   */
   cateImage(data) {
    return request._get('/shop/plus.article.category/image', data);
  },
  settingDetail(data){
    return request._get('/shop/plus.article.article/setting',data);
  },
  editSetting(data){
    return request._post('/shop/plus.article.article/setting',data);
  },
  // 批量修改文章状态
  setStatusList(data){
    return request._post('/shop/plus.article.article/batchEditStatus',data);
  },

}
export default ArticleApi;



// WEBPACK FOOTER //
// ./src/api/article.js